import { z } from 'zod';
/**
 * 联系人分组（平台级，按公司分组）。
 * - 平台管理员统一维护；产品可「从分组导入」把该组联系人复制进本产品通知联系人。
 * - 编辑分组联系人时可选 sync=true → 推送到已导入该分组的产品（按来源标记匹配）。
 */
export const ContactGroupMetaSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1).max(100), // 分组名
    company: z.string().min(1).max(100), // 所属公司
    note: z.string().max(500).optional(),
    contact_count: z.number().int().nonnegative().optional(),
    created_at: z.number().int(),
    created_by_user_id: z.string(),
    updated_at: z.number().int(),
});
export const CreateContactGroupSchema = z.object({
    name: z.string().trim().min(1).max(100),
    company: z.string().trim().min(1).max(100),
    note: z.string().max(500).optional(),
});
export const UpdateContactGroupSchema = z
    .object({
    name: z.string().trim().min(1).max(100).optional(),
    company: z.string().trim().min(1).max(100).optional(),
    note: z.string().max(500).optional(),
})
    .strict();
/** 分组内的联系人 */
export const GroupContactSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email().toLowerCase().max(254),
    name: z.string().min(1).max(100),
    role_label: z.string().max(50).optional(),
    note: z.string().max(500).optional(),
    created_at: z.number().int(),
    updated_at: z.number().int(),
});
export const CreateGroupContactSchema = z.object({
    email: z.string().trim().email().toLowerCase().max(254),
    name: z.string().trim().min(1).max(100),
    role_label: z.string().trim().max(50).optional(),
    note: z.string().max(500).optional(),
    /** 同步到已导入该分组的产品 */
    sync: z.boolean().default(false),
});
export const UpdateGroupContactSchema = z
    .object({
    name: z.string().trim().min(1).max(100).optional(),
    role_label: z.string().trim().max(50).optional(),
    note: z.string().max(500).optional(),
    sync: z.boolean().default(false),
})
    .strict();
/** 产品：从分组导入联系人 */
export const ImportGroupSchema = z.object({
    group_id: z.string().uuid(),
});
//# sourceMappingURL=contact-group.js.map